import GlobalHierarchyModel from "../../models/master-data-management/global-hierarchy/global-hierarchy.model";
import ViewBase from "../../views/view-base.view";
import TreeInputComponent from "../treeview/tree-input.component";

export default function ProductSelectionComponent() {
    ViewBase.call(this);

    let productList = []

    let transformToTreeNodeDataObject = (oriObject, parentCode = null) => {
        const transformedObj = {
            code: oriObject.code,
            name: oriObject.name
        }

        if (parentCode !== null) {
            transformedObj.parentCode = parentCode;
        }

        if (oriObject.children?.length > 0) {
            transformedObj.children = oriObject.children.map(childItem => transformToTreeNodeDataObject(childItem, transformedObj.code))
        }

        return transformedObj;
    }

    let buildProductHierarchyList = (rawList = []) => {
        productList = rawList.map(item => transformToTreeNodeDataObject(item));
    }

    const getProductHierarchyList = () => {
        GlobalHierarchyModel.getHierarchyTree('GLOBPRODUCTHIR')
            .then(buildProductHierarchyList)
    }

    return {
        oninit: () => {
            getProductHierarchyList();
        },
        view: ({ attrs: { selectedItems, onChange, required, disabled } }) => m(TreeInputComponent, {
            title: this.getText('LT00000579', 'Product'),
            items: productList,
            selectedItems,
            required,
            disabled,
            onChange
        })

    }
}